import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <section className="py-20 mt-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Contact Us</h2>
            <div className="w-24 h-1 bg-[#d40715] mx-auto mb-6"></div>
            <p className="max-w-2xl mx-auto text-gray-600">
              Get in touch with us for any inquiries about our services
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="bg-white rounded-lg shadow-md p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Hong Kong Head Office</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <MapPin className="text-[#d40715] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Address</h4>
                    <p className="text-gray-600">
                      Hop Shing Engineering & Construction Limited<br />
                      Unit B, 3/F, Ocean Industrial Building,<br />
                      29 Tai Yip Street, Kwun Tong,<br />
                      Kowloon, Hong Kong
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Phone className="text-[#d40715] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Phone & Fax</h4>
                    <p className="text-gray-600">
                      Tel: <a href="tel:+85225703759" className="hover:text-[#d40715]">(852) 2570 3759</a><br />
                      Fax: (852) 2570 4329
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Mail className="text-[#d40715] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Email</h4>
                    <a 
                      href="mailto:info@hopshingengineering.com" 
                      className="text-gray-600 hover:text-[#d40715]"
                    >
                      info@hopshingengineering.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Clock className="text-[#d40715] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Business Hours</h4>
                    <p className="text-gray-600">
                      Monday - Friday: 9:00 AM - 6:00 PM<br />
                      Saturday: 9:00 AM - 1:00 PM<br />
                      Sunday & Public Holidays: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="h-[500px] rounded-lg overflow-hidden shadow-md">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0876600168145!2d114.22324687596333!3d22.31236447979657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34040146c53f4bc7%3A0x8fc0d420b9e9e1ba!2sOcean%20Industrial%20Building!5e0!3m2!1sen!2sus!4v1709655774044!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default Contact;